import {
  Validator
} from 'vee-validate';
import {
  BasicSelect
} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination';
import VueMaterial from 'vue-material';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import BookingService from './../../../../services/cargobooking.service';
import ClientService from './../../../../../clientmanagement/services/clientmanagement.service';
import Util from './../../../../../shared/util/util';
import adminsettingsService from '../../../../../adminsettings/services/adminsettings.service';


export default {
  name: 'detailedinformation',
  components: {
    BasicSelect,
    VueMaterial,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading
  },
  props: ['bookingData', 'status'],
  data() {
    return {
      accordianTab: {
        1: false,
        2: false,
        3: false,
        4: false
      },
      expanded: false,
      EBNlimit:50000,
      CompanyName: '',
      ATTN: '',
      Beneficiary: '',
      SelfCollectByClient: false,
      isDetailedInfoLoading: false,
      State: '',
      City: '',
      PinCode: '',
      HoldDays: '',
      ReferenceNo: '',
      EWBExpiryDate: '',
      InvoiceNumber: '',
      clientReferenceNo: '',
      AddNewConsigneeFlag: false,
      CompanyName: '',
      CSTTINNo: '',
      Telephone: '',
      Email: '',
      Mobile: '',
      EWBNumber: '',
      InvoiceValue: '',
      Address: '',
      VTCPayment: null,
      RequestedToTime: '',
      RequestedFromTime: '',
      CollectionAmount: '',
      Consignee: null,
      ConsigneeCode: '',
      RequestedDeliveryDate: '',
      RequestedPickupDate: '',
      RequestedPickupFromTime: '',
      MallDelivery: false,
      HsnCode: '',
      VTCPaymentList: [{
          id: "Cash",
          label: "Cash"
        },
        {
          id: "Cheque",
          label: "Cheque"
        },
        {
          id: "Demand Draft (DD)",
          label: "Demand Draft (DD)"
        }
      ],
      Consigneelist: [],
      detailedInformationData: [],
      userName: "",
      invoiceData: [],
      totalinvoicevalue: 0,
      form: {
        InvoiceNumber: [],
        InvoiceValue: [],
        EWBNumber: [],
        EWBExpiryDate: [],
        validated: [],
        isvalid: [],
        ishsnverified: [],
        EWBResponse: [],
        IsEwbnExempted: [],
        HsnCode: [],
      },
      ewbDetailsList: {},
      EBNInfoPopup: false,
      EBNInfoErrorPopup: false,
      editValueAddedServicesflag: false,
      editflag: false,
      ofdflag: false,
      ewbDetailsErrorList: {},
      hsnlist: [],
      totalshipmentvalues: '',
      productname: null,
      productlist:[],
      misccategory:'',
      clientreferencemandatory:false,
      referencemandatory:false,
      ebnpopupshow:true,
      disableSelfCollectByClient:false,
      otpFlag:false
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if (this.bookingData.id) {
      if (this.bookingData.intrastate==1) {
        this.EBNlimit = 100000;
      }
      if (this.bookingData.status == 3) {
        this.editflag = true;
        this.editValueAddedServicesflag = false;
      }
      if (this.bookingData.status > 3) {
        this.editValueAddedServicesflag = true;
        this.editflag = true;
      }
      if (this.bookingData.status >= 4) {
        this.ofdflag = true;
      }
      if (this.bookingData.bookingstatus == "Complete") {
        this.editflag = true;
        this.editValueAddedServicesflag = true;
      }
      if (this.bookingData.routemode == 'Air' && this.bookingData.bookingmode == 'PrePaid') {
        this.SelfCollectByClient = true;
        this.disableSelfCollectByClient = true;
      }
      await Promise.all([
        this.getConsigneeLocationList(),
        this.getInvoiceData(this.bookingData.id),
        this.getProductCategoryList(),
		    this.getClientConfiguration(this.bookingData.clientid,this.bookingData.clientbusinessaccountid)
      ]);
    }
  },
  methods: {
    async checkhover(){
      const btn = document.getElementById('btn'),
      tooltip = document.getElementById('tooltip');
      if (tooltip.style.display === "none") {
        tooltip.style.display = "block";
        setTimeout(()=> {
          tooltip.style.display  = "none";
        }, 2000);
    }
    else{
      tooltip.style.display  = "none";
    }
    },
    handleTab(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
        if (tabid = 1) {
          this.accordianTab[2] = true;
          this.accordianTab[3] = false;
        }
      }
    },
    handleTab1(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
        if (tabid = 2) {
          this.accordianTab[3] = true;
        }
      }
    },
    handleTab2(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
        if (tabid = 3) {
          this.accordianTab[4] = true;
        }
      }
    },
    handleTab3(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
      }
    },
    childMethod(tabtype, subtabid, clientid, pincode, location) {
      if (tabtype == 'subtab') {
        this.accordianTab[subtabid] = true;
        this.toggleCheck(subtabid);
        if (location) {
          if (location.id && location.id != "") {
            this.Consignee = location;
          } else {
            this.Consignee = null;
            this.Address = "";
          }
          this.AddNewConsigneeFlag = false;
          this.getConsigneeLocationList();
        }
      }
    },
    getTotalInvoiceValue() {
      let total = 0;
      for (var i in this.form.InvoiceValue) {
        total += parseFloat(this.form.InvoiceValue[i]);
      }
      this.totalinvoicevalue = total.toFixed(2);
      return total.toFixed(2);
    },
    setname(id, name) {
      return name + id;
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    selectedVTCPayment() {

    },
    ChkCollectByClient() {
      if (!this.SelfCollectByClient && this.Consigneelist.length == 1) {
        this.Consignee = this.Consigneelist[0];
        this.CompanyName = this.Consignee.consigneename;
        this.Mobile = this.Consignee.mobile;
        this.Telephone = this.Consignee.telephone;
        this.Email = this.Consignee.email;
        this.Address = this.Consignee.address;
        this.ATTN = this.Consignee.attn;
        this.CSTTINNo = this.Consignee.csttin;
        this.AddNewConsigneeFlag = false;
      } else if (!this.SelfCollectByClient && this.Consigneelist.length != 1) {
        this.Consignee = null;
        this.CompanyName = "";
        this.Mobile = "";
        this.Telephone = "";
        this.Email = "";
        this.Address = "";
        this.ATTN = "";
        this.CSTTINNo = "";
        this.AddNewConsigneeFlag = false;
      }else{
        this.CompanyName = "";
        this.Mobile = "";
        this.Telephone = "";
        this.Email = "";
        this.Address = "";
        this.ATTN = "";
        this.CSTTINNo = "";
      }
      this.ConsigneeCode = "";
    },
    selectedConsignee() {
      if (this.Consignee) {
        this.CompanyName = this.Consignee.consigneename;
        this.Mobile = this.Consignee.mobile;
        this.Telephone = this.Consignee.telephone;
        this.Email = this.Consignee.email;
        this.Address = this.Consignee.address;
        this.ATTN = this.Consignee.attn;
        this.CSTTINNo = this.Consignee.csttin;
      } else {
        this.CompanyName = null;
        this.Mobile = null;
        this.Telephone = null;
        this.Email = null;
        this.Address = null;
        this.ATTN = null;
        this.CSTTINNo = null;
      }
    },
    addNewConsigneeLocation() {
  	  if(this.otpFlag){
  		    this.$alert("The Client is enabled for OTP based deliveries, the OTP will be sent to the Consignee given number. Please make sure the correct consignee number is added.", "", "success");
  	  }
      this.AddNewConsigneeFlag = true;
      this.ConsigneeCode = null;
      this.CompanyName = this.bookingData.consingneename;
      this.Mobile = this.bookingData.consingneemobile;
      this.Telephone = this.bookingData.consingneetelephone;
      this.Email = this.bookingData.consingneeemail;
      this.Address = this.bookingData.consingneeaddress;
      this.ATTN = this.bookingData.consingneeattn;
      this.CSTTINNo = this.bookingData.consingneecsttin;
    },
    async getConsigneeLocationList() {
      try {
        this.Consigneelist = [];
        let InputPayload = {
          clientid: this.bookingData.clientid,
          pincode: this.bookingData.destinationpincode,
          clientbusinessaccountid: this.bookingData.clientbusinessaccountid,
          csttin: this.bookingData.consingneecsttin
        }
        this.isDetailedInfoLoading = true;
        let result = await BookingService.getConsigneeLocationList(InputPayload);
        let locationdata = result.data.data;
        for (var i = 0; i < locationdata.length; i++) {
          this.Consigneelist.push({
            'id': locationdata[i].consigneecode,
            'label': locationdata[i].consigneecode,
            'consigneename': locationdata[i].consigneename,
            'email': locationdata[i].email,
            'mobile': locationdata[i].mobile,
            'telephone': locationdata[i].telephone,
            'attn': locationdata[i].attn,
            'csttin': locationdata[i].csttin,
            'address': locationdata[i].address
          })
        }
        if (this.Consigneelist.length == 1 && this.Consignee == null && this.SelfCollectByClient == false) {
           this.Consignee = this.Consigneelist[0];
        }
        if(this.Consigneelist.length ==0){
          this.CompanyName = this.bookingData.consingneename;
          this.Mobile = this.bookingData.consingneemobile;
          this.Telephone = this.bookingData.consingneetelephone;
          this.Email = this.bookingData.consingneeemail;
          this.ATTN = this.bookingData.consingneeattn;
          this.CSTTINNo = this.bookingData.consingneecsttin;
          this.Address = this.bookingData.consingneeaddress;
          this.AddNewConsigneeFlag = true;
        }
        this.isDetailedInfoLoading = false;
      } catch (err) {
        console.log(err);
        this.isDetailedInfoLoading = false;
      }
    },
    async getInvoiceData(bookingid) {
      try {
        this.detailedInformationData = [];
        let InputPayload = {
          bookingid: bookingid
        }
        this.isDetailedInfoLoading = true;
        let response = await BookingService.getInvoiceData(InputPayload);
        let invoicedata = response.data.data;
        invoicedata.sort((a,b) => b.validated - a.validated); // b - a for reverse sort
        let noofinvoices = (this.bookingData.updatednoofinvoices) ? this.bookingData.updatednoofinvoices : this.bookingData.numberofinvoices;
        for (var i = 0; i < noofinvoices; i++) {
          let isvalid = "";
          let EWBResponse = "";
          if(invoicedata[i]){
            if (invoicedata.length != noofinvoices) {
              invoicedata[i].validated = 0;
            }
            if(parseInt(invoicedata[i].invoicevalue) >= this.EBNlimit && invoicedata[i].validated == 1 && invoicedata[i].isewbnexempted != 1){
              isvalid = 1;
            }else{
              isvalid = 0;
            }
            if(parseInt(invoicedata[i].invoicevalue) >= this.EBNlimit && invoicedata[i].validated == 1 && invoicedata[i].isewbnexempted != 1){
              EWBResponse = invoicedata.validatedresponse;
            }else{
              EWBResponse = null;
            }
          }
          this.invoiceData.push({
            'InvoiceNumber': (invoicedata[i] && invoicedata[i].invoicenumber)?invoicedata[i].invoicenumber:"",
            'InvoiceValue': (invoicedata[i] && invoicedata[i].invoicevalue)?invoicedata[i].invoicevalue:"",
            'EWBNumber': (invoicedata[i] && invoicedata[i].ewbnumber)?invoicedata[i].ewbnumber:"",
            'EWBExpiryDate': (invoicedata[i] && invoicedata[i].expirydate)?invoicedata[i].expirydate:"",
            'validated': (invoicedata[i] && invoicedata[i].isewbnexempted == 1) ? 0 : (invoicedata[i] && invoicedata[i].validated && invoicedata[i].expirydate)?invoicedata[i].validated:0,
            'isvalid': isvalid,
            "EWBResponse": EWBResponse,
            'IsEwbnExempted': (invoicedata[i] && invoicedata[i].isewbnexempted)?invoicedata[i].isewbnexempted:0,
            'HsnCode': (invoicedata[i] && invoicedata[i].hsncode)?invoicedata[i].hsncode:"",
            'ishsnverified': (invoicedata[i] && invoicedata[i].isewbnexempted == 1) ? 1 : 0,
          });

          this.form.InvoiceNumber[i] = (invoicedata[i] && invoicedata[i].invoicenumber)?invoicedata[i].invoicenumber:null;
          this.form.InvoiceValue[i] = (invoicedata[i] && invoicedata[i].invoicevalue)?invoicedata[i].invoicevalue:null;
          this.form.EWBNumber[i] = (invoicedata[i] && invoicedata[i].ewbnumber)?invoicedata[i].ewbnumber:null;
          this.form.EWBExpiryDate[i] = (invoicedata[i] && invoicedata[i].expirydate) ? Util.DateOnlyFormat(invoicedata[i].expirydate) : null;
          this.form.IsEwbnExempted[i] = (invoicedata[i] && invoicedata[i].isewbnexempted)?invoicedata[i].isewbnexempted:0;
          this.form.HsnCode[i] = (invoicedata[i] && invoicedata[i].hsncode)?invoicedata[i].hsncode:null;
          this.form.ishsnverified[i] = (invoicedata[i] && invoicedata[i].isewbnexempted) ? invoicedata[i].isewbnexempted : 0;
          this.form.validated[i] = (invoicedata[i] && invoicedata[i].isewbnexempted && invoicedata[i].isewbnexempted == 1) ? 0 : (invoicedata[i] && invoicedata[i].validated && invoicedata[i].expirydate)?invoicedata[i].validated:0;
          this.form.isvalid[i] = (invoicedata[i] && invoicedata[i].validated && invoicedata[i].expirydate)?invoicedata[i].validated:0;
          this.form.EWBResponse[i] = (invoicedata[i] && invoicedata[i].validatedresponse)?invoicedata[i].validatedresponse:null;
        };
        if (noofinvoices == 1 && invoicedata.length == 0 && this.bookingData.bookingmethod == 'Upload') {
          this.form.InvoiceValue[0] = this.bookingData.totalshipmentvalues;
        }
        this.detailedInformationData = this.bookingData;
        this.setValues();
      } catch (err) {
        this.isDetailedInfoLoading = false;
        console.log(err);
      }
    },
    setValues() {
      this.bookingid = this.detailedInformationData.id;
      if (this.bookingData.routemode == 'Air' && this.bookingData.bookingmode == 'PrePaid') {
        this.SelfCollectByClient = true;
      }else{
        this.SelfCollectByClient = this.detailedInformationData.pickbyclient;
      }
      this.MallDelivery = this.detailedInformationData.malldelivery;
      this.PinCode = this.detailedInformationData.destinationpincode;
      this.City = this.detailedInformationData.consingneecity;
      this.State = this.detailedInformationData.consingneestate;
      if (this.detailedInformationData.consingneecode) {
        this.Consignee = {
          id: this.detailedInformationData.consingneecode,
          label: this.detailedInformationData.consingneecode,
          consigneename: this.detailedInformationData.consingneename,
          email: this.detailedInformationData.consingneeemail,
          mobile: this.detailedInformationData.consingneemobile,
          telephone: this.detailedInformationData.consingneetelephone,
          attn: this.detailedInformationData.consingneeattn,
          csttin: this.detailedInformationData.consingneecsttin,
          address: this.detailedInformationData.consingneeaddress
        }
        this.ConsigneeCode  = this.detailedInformationData.consingneecode;
      }
      if (this.detailedInformationData.pickbyclient == 1){
        this.CompanyName = this.detailedInformationData.consingneename;
        this.Mobile = this.detailedInformationData.consingneemobile;
        this.Telephone = this.detailedInformationData.consingneetelephone;
        this.Email = this.detailedInformationData.consingneeemail;
        this.ATTN = this.detailedInformationData.consingneeattn;
        this.CSTTINNo = this.detailedInformationData.consingneecsttin;
     }
      this.ReferenceNo = this.detailedInformationData.refnumber;
      this.clientReferenceNo = this.detailedInformationData.clientrefnumber;
      this.productname = this.detailedInformationData.productcategories;
      this.misccategory = this.detailedInformationData.misccategory;
      this.RequestedDeliveryDate = this.detailedInformationData.requesteddeliverydate;
      this.RequestedPickupDate = this.detailedInformationData.requestedpickupdate;
      this.RequestedFromTime = this.detailedInformationData.requesteddeliverytimefrom;
      this.RequestedToTime = this.detailedInformationData.requesteddeliverytimeto;
      this.RequestedPickupFromTime = this.detailedInformationData.requestedpickuptimefrom;
      this.HoldDays = this.detailedInformationData.holddelivery;
      this.CollectionAmount = this.detailedInformationData.collectionamount;
      this.totalinvoicevalue = this.detailedInformationData.totalinvoicevalue;
      this.totalshipmentvalues = this.detailedInformationData.totalshipmentvalues;
      this.VTCPayment = this.detailedInformationData.vtcpaymentmode;
      this.Beneficiary = this.detailedInformationData.benificiary;
      this.isDetailedInfoLoading = false;
    },
    checkConsigneeDetailsValidation() {
      this.$validator.validateAll("consigneedetailsform").then( async (result) => {
        if (result) {
          var inputPayload = {};
          if (this.AddNewConsigneeFlag == true) {
            inputPayload.ConsigneeCode = this.ConsigneeCode;
            inputPayload.DestinationPincode = this.bookingData.destinationpincode;
          } else {
            inputPayload.ConsigneeId = (this.SelfCollectByClient == false ? this.Consignee.id : null);
            inputPayload.ConsigneeCode = (this.SelfCollectByClient == false ? this.Consignee.label : "");
          }

          inputPayload.SelfCollectByClient = (this.SelfCollectByClient == true ? 1 : 0);
          inputPayload.CompanyName =  this.CompanyName;
          inputPayload.Mobile =  this.Mobile;
          inputPayload.ATTN =  this.ATTN;
          inputPayload.Telephone =  this.Telephone;
          inputPayload.Email =  this.Email;
          inputPayload.CSTTINNo =  this.CSTTINNo;
          inputPayload.Address = (this.SelfCollectByClient == false ? this.Address: "");
          inputPayload.lastmodifiedby = this.userName;
          this.editflag = true
          await this.$emit("savebooking", inputPayload, "saveConsigneeDetails");
          this.editflag = false
        } else {
          return false;
        }
      }).catch((err) => {
        console.log('errors exist', err);
        return false;
      });
    },
    checkShipmentDetailsValidation() {
      this.$validator.validateAll("shipmentdetailsform").then(async (result) => {
        if (result) {
          var inputPayload = {};
          inputPayload.ReferenceNo = this.ReferenceNo;
          inputPayload.clientReferenceNo = this.clientReferenceNo;
          inputPayload.lastmodifiedby = this.userName;
          inputPayload.productname = this.productname;
          if(this.misccategory){
            inputPayload.misccategory = this.misccategory
          }
          this.editflag =true;
          await this.$emit("savebooking", inputPayload, "saveDetailedShipmentDetails");
          this.editflag =false;
        } else {
          return false;
        }
      }).catch((err) => {
        console.log('errors exist',err);
        return false;
      });
    },
    checkInvoiceGSTDetailsValidation() {
      this.$validator.validateAll("invoicegstdetailsform").then((result) => {
        if (result) {
          var inputPayload = {};
          let invoicedetails = [];
          let total = 0;
          let validinvoiceflag = 0;
          let invno = [];
          let ewbno = [];
          let missingEBNInvoices = [];
          for (var i = 0; i < this.form.InvoiceNumber.length; i++) {
            $("#InvoiceNumber"+i).removeClass('error');
            $("#EWBNumber"+i).removeClass('error');
            if(!this.form.EWBNumber[i] && this.form.IsEwbnExempted[i] == "0"){
              missingEBNInvoices.push(this.form.InvoiceNumber[i]);
            }
            if ((this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") && (this.form.IsEwbnExempted[i] == "0" && this.form.validated[i] == 0)) {
              validinvoiceflag = 1;
            }
            if (this.form.isvalid[i] == 3) {
              validinvoiceflag = 2;
            }
            if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 0) {
              validinvoiceflag = 3;
            }
            if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 2) {
              validinvoiceflag = 4;
            }
            total += parseFloat(this.form.InvoiceValue[i]);
            invoicedetails.push({
              InvoiceNumber: this.form.InvoiceNumber[i],
              InvoiceValue: this.form.InvoiceValue[i],
              EWBNumber: this.form.EWBNumber[i],
              EWBExpiryDate: (this.form.EWBExpiryDate[i]) ? this.form.EWBExpiryDate[i] : null,
              EWBValidate: (this.form.IsEwbnExempted[i] == 1 ? 0 : this.form.isvalid[i]),
              validatedresponse: (this.form.EWBResponse[i]) ? this.form.EWBResponse[i] : null,
              IsEwbnExempted: (this.form.IsEwbnExempted[i] == true ? 1 : 0),
              HsnCode: this.form.HsnCode[i]
            });
            if(invno.includes(this.form.InvoiceNumber[i])){
              $("#InvoiceNumber"+i).addClass('error');
            }
            invno.push(this.form.InvoiceNumber[i]);
            if (this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") {
              if(ewbno.includes(this.form.EWBNumber[i])){
                $("#EWBNumber"+i).addClass('error');
              }
              ewbno.push(this.form.EWBNumber[i]);
            }
          }

          let uniqueinvno = invno.filter((v, i) => invno.indexOf(v) == i);
          if (uniqueinvno.length != invno.length) {
            this.$alert("Duplicates Invoice Numbers are exists", "", "error");
            return false;
          }

          let uniqueewbno = ewbno.filter((v, i) => ewbno.indexOf(v) == i);
          if (uniqueewbno.length != ewbno.length) {
            this.$alert("Duplicates EWB Numbers are exists", "", "error");
            return false;
          }
          if (this.totalshipmentvalues != total) {
            document.activeElement.blur();
            this.$alert("Total Invoice Value should be equal to Total Shipment Value", "", "info");
          }

          inputPayload.invoicedetails = invoicedetails;
          this.totalinvoicevalue = total.toFixed(2);
          inputPayload.totalinvoicevalue = this.totalinvoicevalue;
          inputPayload.lastmodifiedby = this.userName;
          if (validinvoiceflag == 1) {
            this.$alert("Please validate EWB", "", "error");
            return false;
          } else if (validinvoiceflag == 2) {
            this.$alert("Invoice Details are not valid", "", "error");
            return false;
          } else if (validinvoiceflag == 3) {
            this.$alert("Please verify HSN code", "", "error");
            return false;
          } else if (validinvoiceflag == 4) {
            this.$alert("HSN Code Invalid", "", "error");
            return false;
          } else {
            this.checkEWBPopup(inputPayload,missingEBNInvoices,'saveInvoiceAndGSTDetails');
          }
        } else {
          return false;
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    async checkEWBPopup(inputPayload,missingEBNInvoices,functioname){
      if(missingEBNInvoices.length>0){
        document.activeElement.blur();
        let invoicesNo = missingEBNInvoices.join(", ");
        let message = "<div style='text-align: left;padding-top:20px;'><p><b>You have not entered any Eway Bill details for the Invoice Numbers "+invoicesNo+". </p><p>Please check and confirm if there are Eway Bill assigned to these Invoices.</b></p> <p style='color:red'><b>If found and penalty levied by GST Officer, you will be liable for the penalty.</b></p></div>"
        this.$fire({
          html: message,
          width: 500,
          textalign: 'left',
          showCancelButton: true,
          cancelButtonColor: '#009C41',
          confirmButtonColor: '#20a8d8',
          confirmButtonText: 'Save And Next <i class="fa fa-arrow-right"></i>',
          cancelButtonText: 'Add EWB',
          reverseButtons: true
          }).then((result) => {
            if(result.value == true) {
              this.ebnpopupshow = false;
      			  this.$emit("savebooking", inputPayload, functioname);
      			}else{
              this.accordianTab[1] = true;
              return false;
            }
          }).catch((err)=>{
           console.log(err)
         });
      }else{
        this.$emit("savebooking", inputPayload, functioname);
      }
    },
    getInvalidInvoices(errData){
      let invArr= [];
      let ebnArr= [];
      for(let i = 0; i< errData.duplicateCheckRes.length; i++){
        if(errData.duplicateCheckRes[i].invoicenumber){
          invArr.push(errData.duplicateCheckRes[i].invoicenumber)
        }
        if(errData.duplicateCheckRes[i].ewbnumber){
          ebnArr.push(errData.duplicateCheckRes[i].ewbnumber)
        }
      }
      for(let i = 0; i<this.form.InvoiceNumber.length; i++){
        if(invArr.includes(this.form.InvoiceNumber[i])){
          $("#InvoiceNumber"+i).addClass('error');
        }
        if(this.form.EWBNumber[i] && ebnArr.includes(this.form.EWBNumber[i])){
          $("#EWBNumber"+i).addClass('error');
        }
      }
    },
    ValidateTime() {
      let temptotime = "00:00";
      if (this.RequestedToTime != null) {
        temptotime = this.RequestedToTime;
      }
      let totime = temptotime.split(':');
      var fromtime = this.RequestedFromTime.split(':');
      var pickupfromtime = this.RequestedPickupFromTime.split(':');
      let totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
      let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
      let totalPickupFromTimeSeconds = parseInt(pickupfromtime[0] * 3600 + pickupfromtime[1] * 60);
      let todaysDate = Util.getCurrentDateOnly();
      let current = new Date();
      let hrs = parseInt(current.getHours());
      let mins = parseInt(current.getMinutes());
      let currentTimeSeconds = (hrs * 3600 + mins * 60)
      if (totalToTimeSeconds <= totalFromTimeSeconds && this.RequestedToTime != null) {
        $("#RequestedToTime").addClass('error');
      } else if (this.RequestedDeliveryDate == this.RequestedPickupDate && totalPickupFromTimeSeconds >= totalFromTimeSeconds) {
        $("#RequestedFromTime").addClass('error');
      } else if (this.RequestedDeliveryDate == todaysDate && currentTimeSeconds >= totalFromTimeSeconds) {
        $("#RequestedFromTime").addClass('error');
      } else {
        $("#RequestedToTime").removeClass('error');
        $("#RequestedFromTime").removeClass('error');
      }
    },
    checkValueAddedServicesValidation() {
      this.$validator.validateAll("valueaddedservicesform").then((result) => {
        if (result) {
          var inputPayload = {};
          inputPayload.RequestedDeliveryDate = this.RequestedDeliveryDate;
          inputPayload.RequestedFromTime = this.RequestedFromTime;
          inputPayload.RequestedToTime = this.RequestedToTime;
          inputPayload.HoldDays = this.HoldDays;
          inputPayload.CollectionAmount = this.CollectionAmount;
          inputPayload.VTCPayment = this.VTCPayment;
          inputPayload.Beneficiary = this.Beneficiary;
          inputPayload.lastmodifiedby = this.userName;

          if (this.RequestedToTime != null && this.RequestedDeliveryDate != null) {
            var totime = this.RequestedToTime.split(':');
            var fromtime = this.RequestedFromTime.split(':');
            var pickupfromtime = this.RequestedPickupFromTime.split(':');
            let totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
            let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
            let totalPickupFromTimeSeconds = parseInt(pickupfromtime[0] * 3600 + pickupfromtime[1] * 60);
            let pickupdate = new Date(this.RequestedPickupDate);
            let deliverydate = new Date(this.RequestedDeliveryDate);
            let todaysDate = Util.getCurrentDateOnly();
            let current = new Date();
            let hrs = parseInt(current.getHours());
            let mins = parseInt(current.getMinutes());
            let currentTimeSeconds = (hrs * 3600 + mins * 60)
            if (deliverydate < pickupdate) {
              $("#RequestedDeliveryDate").addClass('error');
              this.$alert("Requested delivery date should be greater than pickup date", "", "error");
            } else if (totalToTimeSeconds <= totalFromTimeSeconds) {
              $("#RequestedToTime").addClass('error');
              this.$alert("Requested delivery To time should be greater than From time", "", "error");
            } else if (this.RequestedDeliveryDate == this.RequestedPickupDate && totalPickupFromTimeSeconds >= totalFromTimeSeconds) {
              $("#RequestedFromTime").addClass('error');
              this.$alert("Requested delivery from time should be greater than pickup from time", "", "error");
            } else if (this.RequestedDeliveryDate == todaysDate && currentTimeSeconds >= totalFromTimeSeconds) {
              $("#RequestedFromTime").addClass('error');
              this.$alert("Requested delivery from time should be greater than current time", "", "error");
            } else {
              $("#RequestedDeliveryDate").removeClass('error');
              $("#RequestedToTime").removeClass('error');
              $("#RequestedFromTime").removeClass('error');
              this.$emit("savebooking", inputPayload, "saveValueAddedServices");
            }
          } else {
            this.$emit("savebooking", inputPayload, "saveValueAddedServices");
          }
        } else {
          return false;
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    validatedeliverydate() {
      if (this.RequestedDeliveryDate != null) {
        let tempfromtime = "00:00";
        let pickupdate = new Date(this.RequestedPickupDate);
        let deliverydate = new Date(this.RequestedDeliveryDate);
        if (this.RequestedFromTime != null) {
          tempfromtime = this.RequestedFromTime;
        }
        let fromtime = tempfromtime.split(':');
        var pickupfromtime = this.RequestedPickupFromTime.split(':');
        let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
        let totalPickupFromTimeSeconds = parseInt(pickupfromtime[0] * 3600 + pickupfromtime[1] * 60);
        let todaysDate = Util.getCurrentDateOnly();
        let current = new Date();
        let hrs = parseInt(current.getHours());
        let mins = parseInt(current.getMinutes());
        let currentTimeSeconds = (hrs * 3600 + mins * 60)

        if (deliverydate < pickupdate) {
          $("#RequestedDeliveryDate").addClass('error');
          this.$alert("Requested delivery date should be greater than pickup date", "", "error");
        } else if (this.RequestedDeliveryDate == this.RequestedPickupDate && totalPickupFromTimeSeconds >= totalFromTimeSeconds) {
          $("#RequestedFromTime").addClass('error');
        } else if (this.RequestedDeliveryDate == todaysDate && currentTimeSeconds >= totalFromTimeSeconds) {
          $("#RequestedFromTime").addClass('error');
        } else {
          $("#RequestedDeliveryDate").removeClass('error');
          $("#RequestedFromTime").removeClass('error');
        }
      }
    },
    async validateEWB(id) {
      try {
        if (this.form.InvoiceNumber[id] == null || this.form.InvoiceNumber[id] == "") {
          this.$alert("Please enter Invoice Number", "", "error");
          return false;
        }
        if (this.form.InvoiceValue[id] == null || this.form.InvoiceValue[id] == "") {
          this.$alert("Please enter Invoice Value", "", "error");
          return false;
        }
        if (this.form.EWBNumber[id] == null || this.form.EWBNumber[id] == "") {
          this.$alert("Please enter EWB Number", "", "error");
          return false;
        }
        if(isNaN(this.form.EWBNumber[id]) || this.form.EWBNumber[id].length < 12) {
          this.$alert("EWB Number must be Numeric and Minimum 12 digits", "", "error");
          return false;
        }

         let InputPayload = {
          InvoiceNumber: this.form.InvoiceNumber[id],
          InvoiceValue: this.form.InvoiceValue[id],
          EWBNumber: this.form.EWBNumber[id]
        }
        this.isDetailedInfoLoading = true;
        let result = await BookingService.validateEWB(InputPayload);
        let responsedata = result.data.data;

        if (result.data.data.isvalid == true) {
          this.form.validated[id] = 1;
          this.form.isvalid[id] = 1;
          this.form.EWBResponse[id] = responsedata.data;

          if(id==0 && (this.detailedInformationData.consingneecsttin=="" || this.detailedInformationData.consingneecsttin==null)){
             this.AddNewConsigneeFlag = true;
             this.CompanyName = (responsedata.data.details.toTrdName)? responsedata.data.details.toTrdName: null;

             let address = null;
             if(responsedata.data.details.toAddr1 && responsedata.data.details.toAddr1 != ""){
               address = responsedata.data.details.toAddr1;
               if(responsedata.data.details.toAddr2 && responsedata.data.details.toAddr2 != ""){
                 address += " "+responsedata.data.details.toAddr2;
               }
             }else if(responsedata.data.details.itemList[0].toAddr1 && responsedata.data.details.itemList[0].toAddr1!=""){
               address = responsedata.data.details.itemList[0].toAddr1;
             }
             this.Address = address;
             this.CSTTINNo = (responsedata.data.details.toGstin)?responsedata.data.details.toGstin: null;
          }
          let newdate;
          if (responsedata.data.details.validUpto) {
            let tempDate = responsedata.data.details.validUpto.split("-");
            let newDate = tempDate[1] + '/' + tempDate[2] + '/' + tempDate[0];
            newdate = Util.DateOnlyFormat(newDate);
          }else{
            newdate = Util.addDaystoCurrentDate(1);
          }
          this.form.EWBExpiryDate[id] = newdate;
        } else {
          if (result.data.data.errormessage[0] == "EWB Vendor API Timeout") {
          	this.form.isvalid[id] = 2;
          	this.form.validated[id] = 1;
          	this.form.EWBResponse[id] = result.data.data.errormessage;
          }else{
          	this.form.isvalid[id] = 3;
          	this.form.validated[id] = 1;
          	this.form.EWBResponse[id] = result.data.data.errormessage;
          }
        }
        this.isDetailedInfoLoading = false;
      } catch (err) {
        console.log(err);
        this.isDetailedInfoLoading = false;
      }
    },
    openEBNInfoPopup(data) {
      this.EBNInfoPopup = true;
      this.ewbDetailsList = data.details;
      this.hsnlist = [];
      let tempArr = [];
      let hsnlist = data.details.itemList;
      for (var i = 0; i < hsnlist.length; i++) {
        let igstrate = 0;
        let cgstrate = 0;
        let sgstrate = 0;
        let gst = 0;
        if (hsnlist[i].igstRate != 0) {
          igstrate = (hsnlist[i].taxableAmount * hsnlist[i].igstRate) / 100;
          gst = hsnlist[i].igstRate;
        } else {
          if (hsnlist[i].cgstRate != 0) {
            cgstrate = (hsnlist[i].taxableAmount * hsnlist[i].cgstRate) / 100;
            gst = gst + hsnlist[i].cgstRate;
          }
          if (hsnlist[i].sgstRate != 0) {
            sgstrate = (hsnlist[i].taxableAmount * hsnlist[i].sgstRate) / 100;
            gst = gst + hsnlist[i].sgstRate;
          }
        }
        let tempObj = {
          "hsnCode": hsnlist[i].hsnCode,
          "GST": gst,
          "cgstRate": cgstrate.toFixed(2),
          "sgstRate": sgstrate.toFixed(2),
          "igstRate": igstrate.toFixed(2)
        }
        tempArr.push(tempObj);
      }
      this.hsnlist = tempArr;
    },
    openErrorEBNInfoPopup(data) {
      if(data.code == 500){
        data = {
          msg: "EWB Vendor API Timeout"
        }
      }
      this.EBNInfoErrorPopup = true;
      this.ewbDetailsErrorList = data;
    },
    closeEBNInfoPopup() {
      this.EBNInfoPopup = false;
    },
    closeErrorEBNInfoPopup() {
      this.EBNInfoErrorPopup = false;
    },
    async saveDetailedInformation() {
      let consigneedetails = await this.$validator.validateAll("consigneedetailsform").then((result) => {
        return result
      });
      let shipmentdetails = await this.$validator.validateAll("shipmentdetailsform").then((result) => {
        return result
      });
      let invoicegstdetails = await this.$validator.validateAll("invoicegstdetailsform").then((result) => {
        return result
      });
      let valueaddedservices = await this.$validator.validateAll("valueaddedservicesform").then((result) => {
        return result
      });

      if (!consigneedetails) {
        this.accordianTab[2] = true;
      } else {
        this.accordianTab[2] = false;
      }
      if (!shipmentdetails) {
        this.accordianTab[3] = true;
      } else {
        this.accordianTab[3] = false;
      }
      if (!invoicegstdetails) {
        this.accordianTab[1] = true;
      } else {
        this.accordianTab[1] = false;
      }
      if (!valueaddedservices) {
        this.accordianTab[4] = true;
      } else {
        this.accordianTab[4] = false;
      }

      if (this.RequestedToTime != null || this.RequestedFromTime != null) {
        if (this.RequestedFromTime != null) {
          var fromtime = this.RequestedFromTime.split(':');
          var totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
        }
        if (this.RequestedToTime != null) {
          var totime = this.RequestedToTime.split(':');
          var totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
        }
        var pickupfromtime = this.RequestedPickupFromTime.split(':');
        let totalPickupFromTimeSeconds = parseInt(pickupfromtime[0] * 3600 + pickupfromtime[1] * 60);
        let pickupdate = new Date(this.RequestedPickupDate);
        let deliverydate = new Date(this.RequestedDeliveryDate);
        let todaysDate = Util.getCurrentDateOnly();
        let current = new Date();
        let hrs = parseInt(current.getHours());
        let mins = parseInt(current.getMinutes());
        let currentTimeSeconds = (hrs * 3600 + mins * 60)
        // if(deliverydate < pickupdate){
        //   $("#RequestedDeliveryDate").addClass( 'error' );
        //   document.activeElement.blur();
        //   this.$alert("Requested delivery date should be greater than pickup date", "", "error");
        //}
        if (this.RequestedToTime != null && this.RequestedFromTime != null) {
          if (totalToTimeSeconds <= totalFromTimeSeconds) {
            $("#RequestedToTime").addClass('error');
            document.activeElement.blur();
            this.$alert("Requested delivery To time should be greater than From time", "", "error");
            this.accordianTab[4] = true;
            return false;
          }
        }
        if (this.RequestedFromTime != null) {
          if (this.RequestedDeliveryDate == this.RequestedPickupDate && totalPickupFromTimeSeconds >= totalFromTimeSeconds) {
            $("#RequestedFromTime").addClass('error');
            document.activeElement.blur();
            this.$alert("Requested delivery from time should be greater than pickup from time", "", "error");
            this.accordianTab[4] = true;
            return false;
          }
          if (this.RequestedDeliveryDate == todaysDate && currentTimeSeconds >= totalFromTimeSeconds) {
            $("#RequestedFromTime").addClass('error');
            document.activeElement.blur();
            this.$alert("Requested delivery from time should be greater than current time", "", "error");
            this.accordianTab[4] = true;
            return false;
          }
        } else {
          $("#RequestedToTime").removeClass('error');
          $("#RequestedFromTime").removeClass('error');
        }
      }


      if (consigneedetails && shipmentdetails && invoicegstdetails && valueaddedservices) {
        var inputPayload = {};
        if (this.AddNewConsigneeFlag == true) {
          inputPayload.ConsigneeCode = this.ConsigneeCode;
          inputPayload.DestinationPincode = this.bookingData.destinationpincode;
        } else {
          inputPayload.ConsigneeId = (this.SelfCollectByClient == false ? this.Consignee.id : null);
          inputPayload.ConsigneeCode = (this.SelfCollectByClient == false ? this.Consignee.label : "");
        }
        inputPayload.SelfCollectByClient = (this.SelfCollectByClient == true ? 1 : 0);
        inputPayload.Address = (this.SelfCollectByClient == false ? this.Address: "");
        inputPayload.CompanyName =  this.CompanyName;
        inputPayload.Mobile =  this.Mobile ;
        inputPayload.ATTN =  this.ATTN;
        inputPayload.Telephone =  this.Telephone ;
        inputPayload.Email =  this.Email;
        inputPayload.CSTTINNo =  this.CSTTINNo;
        inputPayload.lastmodifiedby = this.userName;

        inputPayload.ReferenceNo = this.ReferenceNo;
        inputPayload.clientReferenceNo = this.clientReferenceNo;
        inputPayload.productname = this.productname;
        if(this.misccategory){
          inputPayload.misccategory = this.misccategory
        }

        let invoicedetails = [];
        let total = 0;
        let validinvoiceflag = 0;
        let invno = [];
        let ewbno = [];
        let missingEBNInvoices = [];
        for (var i = 0; i < this.form.InvoiceNumber.length; i++) {
          if(!this.form.EWBNumber[i] && this.form.IsEwbnExempted[i] == "0"){
            missingEBNInvoices.push(this.form.InvoiceNumber[i]);
          }
          if ((this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") && (this.form.IsEwbnExempted[i] == "0" && this.form.validated[i] == 0)) {
            validinvoiceflag = 1;
          }
          if (this.form.isvalid[i] == 3) {
            validinvoiceflag = 2;
          }
          if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 0) {
            validinvoiceflag = 3;
          }
          if (this.form.IsEwbnExempted[i] == 1 && this.form.ishsnverified[i] == 2) {
            validinvoiceflag = 4;
          }
          total += parseFloat(this.form.InvoiceValue[i]);
          invoicedetails.push({
            InvoiceNumber: this.form.InvoiceNumber[i],
            InvoiceValue: this.form.InvoiceValue[i],
            EWBNumber: this.form.EWBNumber[i],
            EWBExpiryDate: (this.form.EWBExpiryDate[i]) ? this.form.EWBExpiryDate[i] : null,
            EWBValidate: (this.form.IsEwbnExempted[i] == 1 ? 0 : this.form.isvalid[i]),
            validatedresponse: (this.form.EWBResponse[i]) ? this.form.EWBResponse[i] : null,
            IsEwbnExempted: (this.form.IsEwbnExempted[i] == 1 ? 1 : 0),
            HsnCode: this.form.HsnCode[i]
          });

          invno.push(this.form.InvoiceNumber[i]);
          if (this.form.EWBNumber[i] != null && this.form.EWBNumber[i] != "") {
            ewbno.push(this.form.EWBNumber[i]);
          }
        }
        let uniqueinvno = invno.filter((v, i) => invno.indexOf(v) == i);
        if (uniqueinvno.length != invno.length) {
          document.activeElement.blur();
          this.$alert("Duplicates Invoice Numbers are exists", "", "error");
          this.accordianTab[1] = true;
          return false;
        }

        let uniqueewbno = ewbno.filter((v, i) => ewbno.indexOf(v) == i);
        if (uniqueewbno.length != ewbno.length) {
          document.activeElement.blur();
          this.$alert("Duplicates EWB Numbers are exists", "", "error");
          this.accordianTab[1] = true;
          return false;
        }
        inputPayload.invoicedetails = invoicedetails;
        this.totalinvoicevalue = total.toFixed(2);

        inputPayload.totalinvoicevalue = this.totalinvoicevalue;
        inputPayload.RequestedDeliveryDate = this.RequestedDeliveryDate;
        inputPayload.RequestedPickupDate = this.RequestedPickupDate;
        inputPayload.RequestedFromTime = this.RequestedFromTime;
        inputPayload.RequestedToTime = this.RequestedToTime;
        inputPayload.RequestedPickupFromTime = this.RequestedPickupFromTime;
        inputPayload.HoldDays = this.HoldDays;
        inputPayload.CollectionAmount = this.CollectionAmount;
        inputPayload.VTCPayment = this.VTCPayment;
        inputPayload.Beneficiary = this.Beneficiary;
        inputPayload.MallDelivery = (this.MallDelivery == true ? 1 : 0);
        if (validinvoiceflag == 1) {
          document.activeElement.blur();
          this.$alert("Please validate EWB", "", "error");
          this.accordianTab[1] = true;
          return false;
        } else if (validinvoiceflag == 2) {
          document.activeElement.blur();
          this.$alert("Invoice Details are not valid", "", "error");
          this.accordianTab[1] = true;
          return false;
        } else if (validinvoiceflag == 3) {
          document.activeElement.blur();
          this.$alert("Please verify HSN code", "", "error");
          this.accordianTab[1] = true;
          return false;
        } else if (validinvoiceflag == 4) {
          document.activeElement.blur();
          this.$alert("HSN Code Invalid", "", "error");
          this.accordianTab[1] = true;
          return false;
        } else {
          if(this.ebnpopupshow){
            this.checkEWBPopup(inputPayload,missingEBNInvoices, "saveDetailedInformation");
          }else{
            this.editflag =true;
            await this.$emit("savebooking", inputPayload, "saveDetailedInformation");
            this.editflag =false;

          }
        }
      }
    },
    async verifyHsnCode(id) {
      try {
        if (this.form.HsnCode[id] == "" || this.form.HsnCode[id] == null) {
          this.$alert("Please enter HSN Code", "", "error");
          return false;
        }
        let InputPayload = {
          HsnCode: this.form.HsnCode[id]
        }
        this.isDetailedInfoLoading = true;
        let result = await BookingService.verifyHSN(InputPayload);
        if (result.data.data.ishsnverified == 1) {
          this.form.ishsnverified[id] = 1;
        } else {
          this.form.ishsnverified[id] = 2;
        }
        this.isDetailedInfoLoading = false;
      } catch (err) {
        console.log(err);
        this.isDetailedInfoLoading = false;
      }
    },
    clearHSNCheckFlag(id) {
      this.form.ishsnverified[id] = 0;
      if (this.form.IsEwbnExempted[id] == "1") {
        this.form.EWBNumber[id] = "";
        this.form.EWBExpiryDate[id] = "";
        this.form.isvalid[id] = 0;
        this.form.EWBResponse[id] = "";
      } else {
        this.form.HsnCode[id] = "";
      }
    },
    clearHSNFlag(id) {
      this.form.ishsnverified[id] = 0;
      this.form.isvalid[id] = 0;
      this.form.EWBResponse[id] = "";
    },
    clearValidateEwbFlag(id) {
      $("#InvoiceNumber"+id).removeClass('error')
      $("#EWBNumber"+id).removeClass('error')
      this.form.isvalid[id] = 0;
      this.form.EWBResponse[id] = "";
      this.form.ishsnverified[id] = 0;
      this.form.validated[id] = 0;
    },
    refreshDate() {
      this.RequestedDeliveryDate = null;
      this.RequestedToTime = null;
      this.RequestedFromTime = null;
      $("#RequestedToTime").removeClass('error');
      $("#RequestedFromTime").removeClass('error');
    },
    async getProductCategoryList() {
      try {
        let result = await BookingService.getProductCategoryList();
        let tempproductList = result.data.data;
        for (var i = 0; i < tempproductList.length; i++) {
          this.productlist.push({
            'id': tempproductList[i].value,
            'label': tempproductList[i].text
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectproductcategories(data){
      if (data.label == "Miscellaneous") {
        this.misccategory = ""
      }
    },

	async getClientConfiguration(clientid,clientbusinessaccid){
		try {
			let input = {
				clientId: clientid,
				clientBusinessAccountId: clientbusinessaccid,
			}
			let result = await adminsettingsService.getClientSettings(input)
			if(result.data.code == 200){
				this.otpFlag = result.data.data[0].configparam.otpbaseddelivery == 1 ? true : false
				this.referencemandatory = result.data.data[0].configparam.referenceno == 1 ? true : false
				this.clientreferencemandatory = result.data.data[0].configparam.clientreferenceno == 1 ? true : false
			}
		} catch (error) {
			console.log(err)
		}
	},
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/Information/detailedinformation/detailedinformation.component.js